module.exports = __webpack_public_path__ + "img/marker.4a30602e.png";